import { render } from "./ListaPermissoes.vue?vue&type=template&id=569e38c8&scoped=true"
import script from "./ListaPermissoes.vue?vue&type=script&lang=js"
export * from "./ListaPermissoes.vue?vue&type=script&lang=js"

import "./ListaPermissoes.vue?vue&type=style&index=0&id=569e38c8&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569e38c8"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QTable,QToggle,QTr,QTh,QTd});
